<template>
  <input v-if="readonly" readonly style="cursor: pointer" :value="preview" />
  <v-select
    v-else
    :options="options"
    :state="false"
    searchable
    v-model="selected"
    @input="change"
  />
</template>

<script>
import { ControlValueAction } from './history'

export default {
  props: [
    'emitter',
    'ikey',
    'readonly',
    'options',
    'handle',
    'getData',
    'putData',
  ],

  data() {
    return {
      value: '',
      preview: '',
      selected: null,
    }
  },

  methods: {
    change(option) {
      const value = option.value

      if (this.value !== value) {
        const editor = this.emitter
        const action = new ControlValueAction(
          editor,
          this._uid,
          this.value,
          value,
          'select'
        )

        editor.trigger('addvaluehistory', action)
        this.write(option)

        // handle event
        if (this.handle) {
          this.handle(option)
        }
      }
    },

    write(option) {
      this.value = option.value
      this.selected = option
      this.putData(this.ikey, this.value)
    },
  },

  mounted() {
    this.value = this.getData(this.ikey)

    this.selected = this.options.find((option) => option.value === this.value)

    if (this.readonly && this.selected) {
      this.preview = this.selected.text
    }

    if (!this.readonly) {
      this.$el.addEventListener('pointerdown', (e) => e.stopPropagation())
      this.$el.addEventListener('mousewheel', (e) => e.stopPropagation())
    }
  },
}
</script>
